import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './DashboardLayout.module.css';

const SIDEBAR_LINKS = [
  { to: '/dashboard', icon: 'dashboard', label: 'Overview', end: true },
  { to: '/dashboard/profile', icon: 'person', label: 'Profile' },
  { to: '/dashboard/listings', icon: 'storefront', label: 'My Listings' },
  { to: '/dashboard/companies', icon: 'business', label: 'Companies' },
  { to: '/dashboard/bookings', icon: 'luggage', label: 'My Bookings' },
  { to: '/dashboard/hosting', icon: 'home', label: 'Hosting' },
  { to: '/dashboard/subscription', icon: 'star', label: 'Subscription' },
  { to: '/dashboard/files', icon: 'photo_library', label: 'My Files' },
  { to: '/dashboard/payouts', icon: 'account_balance', label: 'Payouts' },
  { to: '/dashboard/solutions', icon: 'grid_view', label: 'Apps' },
];

export function DashboardLayout() {
  const { user, loading, logout } = useAuth();

  if (loading) return <div className={styles.loading}>Loading…</div>;
  if (!user) return <Navigate to="/auth/login" replace />;

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <NavLink to="/" className={styles.logo}>
          🌿 UrbanLife<span>.Works</span>
        </NavLink>

        <nav className={styles.nav}>
          {SIDEBAR_LINKS.map(({ to, icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
            >
              <span className="material-icons">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        <div className={styles.footer}>
          <div className={styles.user}>
            <div className={styles.avatar}>
              {(user.full_name ?? user.email)[0].toUpperCase()}
            </div>
            <div>
              <div className={styles.userName}>{user.full_name ?? 'Member'}</div>
              <div className={styles.userEmail}>{user.email}</div>
            </div>
          </div>
          <button onClick={logout} className={styles.signOut} title="Sign out">
            <span className="material-icons">logout</span>
          </button>
        </div>
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
